import { ConnectionType } from '../../@types/network-information.type';

export function getEffectiveConnectionType(): string {
  return window.navigator &&
    window.navigator.connection &&
    window.navigator.connection.effectiveType
    ? window.navigator.connection.effectiveType.toUpperCase()
    : 'unknown';
}

export function getConnectionType(): string {
  return window.navigator &&
    window.navigator.connection &&
    window.navigator.connection.type
    ? window.navigator.connection.type.toUpperCase()
    : ConnectionType.WIFI;
}
